module.exports = __webpack_public_path__ + "files/bdb74352f84954eb08ff3da06e912565.png";